// BSS Portal - Dual Language Translations (BM / EN)

export const translations = {
  // ========== COMMON ==========
  dashboard: { ms: 'Dashboard', en: 'Dashboard' },
  quiz: { ms: 'Quiz', en: 'Quiz' },
  leaderboard: { ms: 'Leaderboard', en: 'Leaderboard' },
  learningProgress: { ms: 'Learning Progress', en: 'Learning Progress' },
  search: { ms: 'Cari...', en: 'Search...' },
  setName: { ms: 'Set Nama', en: 'Set Name' },
  save: { ms: 'Simpan', en: 'Save' },
  cancel: { ms: 'Batal', en: 'Cancel' },
  back: { ms: 'Kembali', en: 'Back' },
  backToList: { ms: 'Kembali ke senarai', en: 'Back to list' },
  loading: { ms: 'Memuat...', en: 'Loading...' },
  delete: { ms: 'Padam', en: 'Delete' },
  organ: { ms: 'Organ', en: 'Organ' },
  point: { ms: 'point', en: 'points' },
  portal: { ms: 'Pembelajaran', en: 'Learning' },

  // ========== DASHBOARD ==========
  dashTitle: { ms: 'Dashboard', en: 'Dashboard' },
  dashSubtitle: { ms: 'Analitik pembelajaran BSS Portal', en: 'BSS Portal Learning Analytics' },
  subTopik: { ms: 'Sub-Topik', en: 'Sub-Topics' },
  avgScore: { ms: 'Purata Skor', en: 'Avg Score' },
  readingProgress: { ms: 'Kemajuan Bacaan', en: 'Reading Progress' },
  continueLearning: { ms: 'Sambung Belajar', en: 'Continue Learning' },
  subTopicPointPerOrgan: { ms: 'Sub-Topik & Point per Organ', en: 'Sub-Topics & Points per Organ' },
  contentDistribution: { ms: 'Agihan Kandungan', en: 'Content Distribution' },
  quizScoreDist: { ms: 'Agihan Skor Quiz', en: 'Quiz Score Distribution' },
  recentQuizScores: { ms: 'Skor Quiz Terkini', en: 'Recent Quiz Scores' },
  noQuizDataYet: { ms: 'Tiada data quiz lagi', en: 'No quiz data yet' },
  tryQuizToSee: { ms: 'Cuba quiz untuk lihat agihan skor.', en: 'Try a quiz to see score distribution.' },
  noQuizAttemptsYet: { ms: 'Tiada percubaan quiz lagi', en: 'No quiz attempts yet' },
  tryQuizToSeeScores: { ms: 'Cuba quiz untuk lihat skor.', en: 'Try a quiz to see scores.' },

  // ========== ORGAN PAGE ==========
  subTopics: { ms: 'Sub-Topik', en: 'Sub-Topics' },
  expandAll: { ms: 'Buka Semua', en: 'Expand All' },
  collapseAll: { ms: 'Tutup Semua', en: 'Collapse All' },
  noSubTopics: { ms: 'Tiada sub-topik lagi.', en: 'No sub-topics yet.' },
  minRead: { ms: 'min bacaan', en: 'min read' },
  read: { ms: 'dibaca', en: 'read' },
  addPersonalNote: { ms: 'Tambah nota peribadi', en: 'Add personal note' },
  editNote: { ms: 'Edit nota', en: 'Edit note' },
  writeYourNote: { ms: 'Tulis nota peribadi anda...', en: 'Write your personal note...' },
  markRead: { ms: 'Tandakan sudah dibaca', en: 'Mark as read' },
  markUnread: { ms: 'Tandakan belum dibaca', en: 'Mark as unread' },
  pdfFiles: { ms: 'Fail PDF', en: 'PDF Files' },

  // ========== QUIZ PAGE ==========
  quizTitle: { ms: 'Quiz', en: 'Quiz' },
  quizSubtitle: { ms: 'Uji pengetahuan anda', en: 'Test your knowledge' },
  generateAIQuiz: { ms: 'Jana Quiz AI', en: 'AI Generate Quiz' },
  createManual: { ms: 'Cipta Manual', en: 'Create Manual' },
  noQuizYet: { ms: 'Tiada quiz lagi', en: 'No quizzes yet' },
  noQuizDesc: { ms: 'Jana quiz secara automatik dengan AI atau cipta sendiri', en: 'Generate quizzes automatically with AI or create manually' },
  createFirstQuiz: { ms: 'Cipta Quiz Pertama', en: 'Create First Quiz' },
  questions: { ms: 'soalan', en: 'questions' },
  start: { ms: 'Mula', en: 'Start' },
  submitAnswers: { ms: 'Hantar Jawapan', en: 'Submit Answers' },
  correct: { ms: 'betul', en: 'correct' },

  // AI Quiz Generate
  aiGenerateTitle: { ms: 'Jana Quiz dengan AI', en: 'Generate Quiz with AI' },
  perOrgan: { ms: 'Per Organ', en: 'Per Organ' },
  fromYourProgress: { ms: 'Dari Progress Anda', en: 'From Your Progress' },
  aiOrganDesc: { ms: 'AI akan membaca kandungan organ yang dipilih dan menjana soalan quiz.', en: 'AI will read the selected organ content and generate quiz questions.' },
  aiOrganSubDesc: { ms: 'Soalan dijana dalam Bahasa Melayu dengan 4 pilihan jawapan.', en: 'Questions generated in Bahasa Melayu with 4 answer choices.' },
  selectOrgan: { ms: '-- Pilih Organ --', en: '-- Select Organ --' },
  numQuestions: { ms: 'Bilangan Soalan', en: 'Number of Questions' },
  generateQuiz: { ms: 'Jana Quiz', en: 'Generate Quiz' },
  generating: { ms: 'Sedang menjana soalan...', en: 'Generating questions...' },
  progressQuizDesc: { ms: 'Quiz dijana berdasarkan apa yang anda SUDAH BACA sahaja.', en: 'Quiz generated based on what you have ALREADY READ only.' },
  progressQuizSubDesc: { ms: 'Pilih organ mana yang anda ingin diuji. Soalan hanya dari point yang ditanda "dibaca".', en: 'Select which organ to be tested on. Questions only from points marked as "read".' },
  noReadContent: { ms: 'Tiada kandungan yang ditanda "dibaca" lagi', en: 'No content marked as "read" yet' },
  noReadContentDesc: { ms: 'Pergi ke halaman Organ, baca kandungan dan tandakan sebagai dibaca.', en: 'Go to Organ pages, read content and mark as read.' },
  selectOrganFromRead: { ms: 'Pilih Organ (dari yang anda dah baca)', en: 'Select Organ (from what you\'ve read)' },
  generateFromProgress: { ms: 'Jana Quiz dari Progress', en: 'Generate Quiz from Progress' },
  generatingFromProgress: { ms: 'Sedang menjana dari progress anda...', en: 'Generating from your progress...' },
  pointRead: { ms: 'point', en: 'points' },
  percentRead: { ms: 'dibaca', en: 'read' },

  // Create Quiz Form
  createNewQuiz: { ms: 'Cipta Quiz Baru', en: 'Create New Quiz' },
  quizTitleLabel: { ms: 'Tajuk Quiz', en: 'Quiz Title' },
  quizTitlePlaceholder: { ms: 'cth: Quiz Organ 1', en: 'e.g.: Quiz Organ 1' },
  organOptional: { ms: 'Organ (pilihan)', en: 'Organ (optional)' },
  questionsLabel: { ms: 'Soalan', en: 'Questions' },
  questionNum: { ms: 'Soalan', en: 'Question' },
  questionPlaceholder: { ms: 'Soalan...', en: 'Question...' },
  optionLabel: { ms: 'Pilihan', en: 'Option' },
  selectCorrectAnswer: { ms: 'Pilih radio untuk jawapan betul', en: 'Select radio for correct answer' },
  addQuestion: { ms: 'Tambah soalan', en: 'Add question' },
  removeQuestion: { ms: 'Buang', en: 'Remove' },
  createQuiz: { ms: 'Cipta Quiz', en: 'Create Quiz' },

  // ========== LEADERBOARD ==========
  lbTitle: { ms: 'Leaderboard', en: 'Leaderboard' },
  lbSubtitle: { ms: 'Kedudukan pelajar berdasarkan prestasi quiz', en: 'Student ranking based on quiz performance' },
  lbEmpty: { ms: 'Leaderboard Kosong', en: 'Leaderboard Empty' },
  lbEmptyDesc: { ms: 'Tiada data lagi. Cuba quiz untuk masuk ke leaderboard!', en: 'No data yet. Try quizzes to enter the leaderboard!' },
  lbEmptyNote: { ms: 'Pastikan anda masukkan nama sebelum menjawab quiz.', en: 'Make sure you enter your name before taking a quiz.' },
  avgScoreLabel: { ms: 'Purata Skor', en: 'Average Score' },
  bestScoreLabel: { ms: 'Skor Terbaik', en: 'Best Score' },
  quizAnswered: { ms: 'Quiz Dijawab', en: 'Quizzes Taken' },
  accuracy: { ms: 'Ketepatan', en: 'Accuracy' },
  allStudents: { ms: 'Semua Pelajar', en: 'All Students' },
  students: { ms: 'pelajar', en: 'students' },
  yourStats: { ms: 'Statistik Anda', en: 'Your Stats' },
  outOf: { ms: 'daripada', en: 'out of' },
  you: { ms: 'Anda', en: 'You' },
  average: { ms: 'purata', en: 'average' },
  best: { ms: 'terbaik', en: 'best' },
  correctAnswers: { ms: 'Jawapan Betul', en: 'Correct Answers' },
  unique: { ms: 'unik', en: 'unique' },
  accurate: { ms: 'tepat', en: 'accurate' },

  // ========== LEARNING PROGRESS ==========
  lpTitle: { ms: 'Learning Progress', en: 'Learning Progress' },
  lpSubtitle: { ms: 'Pantau kemajuan pembelajaran anda', en: 'Track your learning progress' },
  readPercent: { ms: 'Dibaca', en: 'Read' },
  pointsCompleted: { ms: 'Point Selesai', en: 'Points Completed' },
  quizTaken: { ms: 'Quiz Dicuba', en: 'Quizzes Taken' },
  progressPerOrgan: { ms: 'Kemajuan Per Organ', en: 'Progress Per Organ' },
  achievements: { ms: 'Pencapaian Anda', en: 'Your Achievements' },
  bestScore: { ms: 'Skor Terbaik', en: 'Best Score' },
  recentAttempts: { ms: 'Percubaan Quiz Terkini', en: 'Recent Quiz Attempts' },
  noAttemptsYet: { ms: 'Tiada percubaan quiz lagi', en: 'No quiz attempts yet' },
  noAttemptsDesc: { ms: 'Cuba quiz untuk lihat kemajuan di sini', en: 'Try quizzes to see progress here' },

  // ========== SEARCH ==========
  searchPlaceholder: { ms: 'Cari topik, sub-topik, atau point...', en: 'Search topics, sub-topics, or points...' },
  noResults: { ms: 'Tiada hasil untuk', en: 'No results for' },
  typeToSearch: { ms: 'Taip untuk mula mencari...', en: 'Type to start searching...' },
  searchInAll: { ms: 'Cari dalam semua 5 Organ, sub-topik & points', en: 'Search across all 5 Organs, sub-topics & points' },
  select: { ms: 'pilih', en: 'select' },
  close: { ms: 'tutup', en: 'close' },

  // ========== STUDENT NAME ==========
  studentName: { ms: 'Nama Pelajar', en: 'Student Name' },
  nameForLeaderboard: { ms: 'Nama anda akan dipaparkan di Leaderboard', en: 'Your name will be displayed on the Leaderboard' },
  enterYourName: { ms: 'Masukkan nama anda...', en: 'Enter your name...' },
  enterNamePrompt: { ms: 'Masukkan nama anda', en: 'Enter your name' },
  forLeaderboard: { ms: 'Untuk muncul di Leaderboard', en: 'To appear on Leaderboard' },
  welcome: { ms: 'Selamat datang', en: 'Welcome' },

  // ========== LOADING ==========
  loadingSyllabus: { ms: 'Memuat BSS Syllabus...', en: 'Loading BSS Syllabus...' },

  // ========== MISC ==========
  ranking: { ms: 'Ranking', en: 'Ranking' },
  progress: { ms: 'Progress', en: 'Progress' },
};

// Hook-like helper
export const t = (key, lang = 'ms') => {
  const entry = translations[key];
  if (!entry) return key;
  return entry[lang] || entry['ms'] || key;
};
